module.exports = __webpack_public_path__ + "img/UOB.9a244d1b.png";